<!-- <page-title *ngIf="isVisible" [title]="'sez.label.request.title'"></page-title> -->
<ng-container *ngIf="isVisible" >
  <!-- (nzOnCancel)="handleCancel()" nzCancelText="{{'sez.save.draft' | translate}}" [nzOkLoading]="confirm.isLoading" nzOkText="Confirm" (nzOnOk)="handleOk()" -->
  <div *ngIf="!isPricingZero">
      <h3 class="mt36">Pricing</h3>
      <nz-divider class="mt0  mb-lg"></nz-divider>
      <nz-table [nzData]="pricingData" [nzShowPagination]="false" [nzLoading]="loading">
        <thead>
          <tr>
            <th>Pricing Item</th>
            <th>Price</th>
            <th>Currency</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of pricingData">
            <td>{{ data.pricingType }}</td>
            <td>{{ data.pricingValue }}</td>
            <td>AED</td>
          </tr>
          <tr>
            <td class="bold">Pricing Total</td>
            <td>{{pricingTotal}}</td>
            <td>AED</td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <div *ngIf="isPricingZero">
      <p>{{'sez.submit.confirm' | translate}}</p>
    </div>
    <nz-divider class="mt0 mb-lg"></nz-divider>
    <div nz-row>
      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" class="text-right">
        <nz-form-control nzLg="24">
          <button nz-button nzType="default" (click)="handleCancel()"> 
            <i nz-icon nzType="close-circle" nzTheme="outline"></i> {{'app.label.not-now' | translate}}
          </button>
          <button  nz-button nzType="primary" (click)="handleOk()" class="ml-lg">
            <i nz-icon nzType="check-circle" nzTheme="outline"></i> {{'sez.save.confirm' | translate}}
          </button>
         </nz-form-control>
      </div>
    </div>
  </ng-container>
  
  <div *ngIf="isPersonnel">
    <nz-table [nzData]="pricingData" [nzShowPagination]="false">
      <thead>
        <tr>
          <th>Pricing Item</th>
          <th>Price</th>
          <th>Currency</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of pricingData">
          <td>{{ data.pricingType }}</td>
          <td>{{ data.pricingValue }}</td>
          <td>AED</td>
        </tr>
        <tr>
          <td class="bold">Pricing Total</td>
          <td>{{pricingTotal}}</td>
          <td>AED</td>
        </tr>
      </tbody>
    </nz-table>
  </div>